
import { useTranslation } from "react-i18next";
import './Loading.css'


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation
} from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';


const Loading = () => {
  const location = useLocation()
  const { t } = useTranslation();

  const loading = useSelector(state => state.loading);

  return <>
    {
      loading ?
        <div className="fixed left-0 top-0 w-screen h-screen bg-black bg-opacity-70 z-[5000]">
          <div className="flex w-full h-full justify-center items-center ">

            <div className="text-sm text-white  !font-bold text-center">
              <div className="loading-spinner mx-auto mb-2"></div>
              加載中
            </div>

          </div>

        </div> : ""
    }
  </>
}
export default Loading